import NAME from "./constants";

export const getLoansRows = store => store[NAME].loansRows || [];
export const gettingLoansRows = store => store[NAME].gettingLoansRows;
export const getLocale = store => store[NAME].locale;
export const getDateFormat = store => store[NAME].dateFormat;
export const getDecimalQuantity = store => store[NAME].decimalQuantity;
export const getLoansRowsByTypeAndCurrency = store => store[NAME].loansRowsByTypeAndCurrency || [];
export const loading = store => store[NAME].gettingLoansRows;
